import { CALL_API } from '../api';

const OAUTH_SINGNUP_TOKEN_REQUEST = 'OAUTH_SINGNUP_TOKEN_REQUEST';
const LOGIN_REQUEST = 'LOGIN_REQUEST';
const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';

const openRoutes = ['/oauth/linkedin', '/', '/event/session'];

export function storeLastURL(path) {
    let cPath = path ? path : window.location.pathname;
    if (!openRoutes.includes(cPath)) {
        localStorage.setItem('last_location', cPath);
    }
}

export function clearLastURL() {
    localStorage.removeItem('last_location');
}

export function showError() {
    return {
        type: 'Error',
        payload: {
            msg: 'There were some error',
            error: true,
        },
    };
}

/**
 * Fetch the latest airmeet token using an external token as auth
 */
export function fetchAuthUserDetail() {
    return {
        [CALL_API]: {
            types: [LOGIN_REQUEST, USER_LOGIN_SUCCESS],
            endpoint: `/user`,
            type: 'json',
            method: 'GET',
        },
    };
}

export function loginWith(userData) {
    localStorage.setItem('user', JSON.stringify(userData));
    return {
        type: 'Login',
        payload: {
            userData: userData,
            error: false,
        },
    };
}

export function onLogout() {
    return {
        type: 'Login',
        payload: null,
    };
}

export function getUsersDetail(userIds) {
    return {
        [CALL_API]: {
            types: ['GET_USERS_DETAIL_REQUEST', 'GET_USERS_DETAIL_RESPONSE'],
            endpoint: `/users?userIds=${userIds}`,
            type: 'json',
            method: 'GET',
        },
    };
}

export function putUserDetails({ guest = false, ...details }) {
    return {
        [CALL_API]: {
            types: ['PUT_USER_DETAILS', 'UPDATE_USER_DETAILS'],
            endpoint: '/users',
            type: 'json',
            method: 'PUT',
            body: details,
        },
    };
}

export function putEventUserDetails(airmeetId, userId, { ...params }) {
    return {
        [CALL_API]: {
            types: ['PUT_EVENT_USER_DETAILS', 'UPDATE_EVENT_USER_DETAILS'],
            endpoint: '/airmeet/user',
            type: 'json',
            method: 'PUT',
            body: { airmeetId, userId, ...params },
        },
    };
}
export function getUserAirmeets(userAuthToken) {
    return {
        [CALL_API]: {
            types: [
                'GET_USERS_AIRMEETS_REQUEST',
                'GET_USERS_AIRMEETS_RESPONSE',
            ],
            endpoint: `/user/events`,
            type: 'json',
            method: 'GET',
        },
    };
}
export function putUserProfileDetails({
    firstName,
    lastName,
    designation,
    company,
    city,
    country,
    profile_img,
    bio,
    metadata,
}) {
    return {
        [CALL_API]: {
            types: ['PUT_USER_DETAILS_REQUEST', 'PUT_USERS_DETAILS_RESPONSE'],
            endpoint: `/users`,
            type: 'json',
            body: {
                firstName,
                lastName,
                company,
                city,
                country,
                designation,
                profile_img,
                bio: bio,
                metadata: metadata ? metadata : {},
            },
            method: 'PUT',
        },
    };
}
